// extracted by mini-css-extract-plugin
module.exports = {"nav":"nav_nav__3DRZc","container":"nav_container__6iGvJ","logo":"nav_logo__1QjYk","logoLink":"nav_logoLink__11cCb","link":"nav_link__dqNhR","select":"nav_select__34gi5"};